var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { breakpoints } from '../../config/media';
const HiddenStyle = styled.div `
  @media (${props => (props.up ? 'min' : 'max')}-width: ${props => props.size}) {
    display: none;
  }
`;
const Hidden = (_a) => {
    var { up = false, size } = _a, props = __rest(_a, ["up", "size"]);
    const userSize = breakpoints[size];
    const direction = up;
    if (!size) {
        console.error('Insert a valid Breakpoint for <Hidden /> Component');
    }
    return (_jsx(HiddenStyle, Object.assign({ up: direction, size: userSize }, { children: props.children })));
};
export default Hidden;
